/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPagedNotificationsResponse } from '../../models/get-paged-notifications-response';

export interface GetNotifications$Params {

/**
 * Pagination cursor pointing to the next page
 */
  next?: string;

/**
 * Filter parameter for filtering notifications based on read, unread and archived.
 */
  filter?: string;
}

export function getNotifications(http: HttpClient, rootUrl: string, params?: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPagedNotificationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotifications.PATH, 'get');
  if (params) {
    rb.query('next', params.next, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPagedNotificationsResponse>;
    })
  );
}

getNotifications.PATH = '/notifications';
